export const TRANSLATION_PATH = (route) => {
  return `views.app.manage.applications.addApplication.${route}`;
};

export const MANUAL_OPTION = {
  id: '0',
  name: 'Add manually'
};
